import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { BANNER_HEIGHT } from 'components/Banner';
import { Small, Medium, ExtraLarge, Large } from 'components/MediaQuery';
import TopNavigationBanner from 'components/TopNavigationBanner';
import BannerContainer from 'containers/BannerContainer';
import TopNavigationDesktopContainer from 'containers/TopNavigationDesktopContainer';
import TopNavigationMobileContainer from 'containers/TopNavigationMobileContainer';
import Theme from 'styles/theme';
import Settings from 'utils/Settings';

const TopNavigation = ({ trackNavigationClick }) => (
  <>
    <div className="TopNavigation">
      {!isEmpty(Settings.globalBanner) && (
        <TopNavigationBanner backgroundColor={Settings.globalBannerBackgroundColor}>
          <BannerContainer
            items={Settings.globalBanner}
            backgroundColor={Settings.globalBannerBackgroundColor}
          />
        </TopNavigationBanner>
      )}
      <Small>
        <TopNavigationMobileContainer trackNavigationClick={trackNavigationClick} />
      </Small>
      <Medium>
        <TopNavigationMobileContainer trackNavigationClick={trackNavigationClick} />
      </Medium>
      <Large>
        <TopNavigationMobileContainer trackNavigationClick={trackNavigationClick} />
      </Large>
      <ExtraLarge>
        <TopNavigationDesktopContainer trackNavigationClick={trackNavigationClick} />
      </ExtraLarge>
    </div>

    <style jsx>{`
      .TopNavigation {
        position: fixed;
        top: 0;
        z-index: ${Theme.get('z-index-top-navigation')};
        width: 100%;
        transition: transform ${Theme.get('transition-duration-fast-ms')}
          ${Theme.get('transition-timing-ease-out')};
      }
    `}</style>
    <style jsx global>{`
      body.Banner--enabled:not(.Banner--visible) .TopNavigation {
        transition-duration: ${Theme.get('transition-duration-ms')};
        transform: translateY(-${BANNER_HEIGHT}px);
      }
    `}</style>
  </>
);

TopNavigation.propTypes = {
  trackNavigationClick: PropTypes.func.isRequired,
};

export default TopNavigation;
